<template>
  <div>
    <SelectorPanel
      type="notifications"
      :text="labels.notifications"
      :dialog-full-height="true"
      :disabled="disabled"
      :force-close="forceClose"
    >
      <template>
        <SelectorPanelHeader
          type="notifications"
          :title="labels.notifications"
          @click-close="handleClickClose"
        ></SelectorPanelHeader>

        <NotificationsTable></NotificationsTable>
      </template>
    </SelectorPanel>
  </div>
</template>

<script>
import { LABELS } from "@/common/constants/labels";

export default {
  name: "NotificationsSelector",
  components: {
    SelectorPanel: () => import("@/components/common/SelectorPanel"),
    SelectorPanelHeader: () =>
      import("@/components/common/SelectorPanelHeader"),
    NotificationsTable: () =>
      import("@/components/notifications/NotificationsTable"),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    labels: LABELS,
    forceClose: null,
  }),
  mounted() {},
  computed: {},
  methods: {
    handleClickClose() {
      this.forceClose = new Date().toISOString();
    },
  },
  watch: {},
};
</script>

<style scoped>
.hyp-places-support-img {
  width: 235px;
}
</style>
